import { useRouter } from 'next/router';
import { useEffect } from 'react';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@/components/shadcn/tabs';
import Overview from '@/components/ui/privacy/Overview';
import PrivacyPolicy from '@/components/ui/privacy/PrivacyPolicy';
import RedactionRequest from '@/components/ui/privacy/RedactionRequest';
import Layout from '@/components/layout/Layout';

export enum privacyPage {
  overview = 'overview',
  privacyPolicy = 'privacy-policy',
  redactionRequest = 'redaction-request',
}

export type Menu = {
  [key in privacyPage]: {
    title: string;
    target: privacyPage;
  };
};

export const menu: Menu = {
  [privacyPage.overview]: {
    title: 'Overview',
    target: privacyPage.overview,
  },
  [privacyPage.privacyPolicy]: {
    title: 'Privacy Policy',
    target: privacyPage.privacyPolicy,
  },
  [privacyPage.redactionRequest]: {
    title: 'Redaction Request',
    target: privacyPage.redactionRequest,
  },
};

export default function Index() {
  const router = useRouter();
  const {
    query: { id },
  } = router;

  const page = Array.isArray(id) ? id[0] : id;

  useEffect(() => {
    const isValid = Object.values(privacyPage).some(
      validPage => validPage === page,
    );

    if (!isValid) {
      router.push('/privacy/overview', undefined, { shallow: true });
    }
  }, [page]);

  const defaultPage = page || privacyPage.overview;

  return (
    <Layout>
      <Tabs value={defaultPage}>
        <TabsList>
          {Object.values(menu).map(item => (
            <TabsTrigger
              value={item.target}
              key={item.target}
              onClick={() =>
                router.push(item.target, undefined, { shallow: true })
              }>
              {item.title}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value={privacyPage.overview}>
          <div className="sm:w-3/4">
            <Overview />
          </div>
        </TabsContent>
        <TabsContent value={privacyPage.privacyPolicy}>
          <div className="sm:w-3/4">
            <PrivacyPolicy />
          </div>
        </TabsContent>
        <TabsContent value={privacyPage.redactionRequest}>
          <RedactionRequest />
        </TabsContent>
      </Tabs>
    </Layout>
  );
}
